'use strict';

/** @UploaderStore */
var UploaderStore = function UploaderStore($http, $rootScope, $q, APP_DISPATCHER_ID, Flux) {

  //Store init
  var UploaderStore = Flux.Store.create({
    name: 'UploaderStore',
    events: {
      Changed: true
    }
  });

  //Null initial state
  UploaderStore.$state = {
    siteName: '',
    captureDate: '',
    state: ''
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  UploaderStore.init = function init() {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);
  }.bind(this);

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handles the visiblilty flag to show/hide the modal
   */
  UploaderStore.setSiteName = (name) => {
    UploaderStore.$set('siteName', name);
    UploaderStore.emit(UploaderStore.Events.Changed);
  };

  UploaderStore.setFlightDate = (date) => {
    UploaderStore.$set('captureDate', date);
    UploaderStore.emit(UploaderStore.Events.Changed);
  };

  UploaderStore.setState = (state) => {
    UploaderStore.$set('state', state);
    UploaderStore.emit(UploaderStore.Events.Changed);
  };

  return UploaderStore;
};

UploaderStore.$inject = ['$http', '$rootScope', '$q', 'APP_DISPATCHER_ID', 'sbFlux'];
module.exports = UploaderStore;



// WEBPACK FOOTER //
// ./src/app/uploader/UploaderStore.js